export const data = [
    {'name': 'Water', 'type': 0, 'cost': 0, 'symbols': [0,2,0], 'icon': 'base_water'},
    {'name': 'Vinegar', 'type': 0, 'cost': 30, 'symbols': [1,2,2], 'icon': 'base_vinegar'},
    {'name': 'Wine', 'type': 0, 'cost': 60, 'symbols': [2,1,1], 'icon': 'base_wine'},
    
    {'name': 'Green slime', 'type': 1, 'cost': 5, 'symbols': [2,2,0], 'icon': 'slime_green'},
    {'name': 'Blue slime', 'type': 1, 'cost': 5, 'symbols': [0,2,2], 'icon': 'slime_blue'},
    {'name': 'Red slime', 'type': 1, 'cost': 10, 'symbols': [2,1,2], 'icon': 'slime_red'},
    {'name': 'Purple slime', 'type': 1, 'cost': 30, 'symbols': [1,2,1], 'icon': 'slime_purple'},
    
    {'name': 'Cilantro', 'type': 2, 'cost': 5, 'symbols': [2,0,2], 'icon': 'herb_cilantro'},
    {'name': 'Lovage', 'type': 2, 'cost': 30, 'symbols': [0,1,2], 'icon': 'herb_lovage'},
    {'name': 'Sage', 'type': 2, 'cost': 30, 'symbols': [2,0,1], 'icon': 'herb_sage'},
    {'name': 'Hemlock', 'type': 2, 'cost': 50, 'symbols': [1,2,1], 'icon': 'herb_hemlock'},
    
    {'name': 'Dandelion root', 'type': 3, 'cost': 10, 'symbols': [0,0,2], 'icon': 'root_dandelion'},
    {'name': 'Mushroom', 'type': 3, 'cost': 30, 'symbols': [0,2,1], 'icon': 'root_mushroom'},
    {'name': 'Mandrake', 'type': 3, 'cost': 60, 'symbols': [2,1,1], 'icon': 'root_mandrake'},
    
    {'name': 'Rose', 'type': 4, 'cost': 20, 'symbols': [1,2,0], 'icon': 'flower_rose'},
    {'name': 'Tulip', 'type': 4, 'cost': 20, 'symbols': [0,1,2], 'icon': 'flower_tulip'},
    {'name': 'Daffodil', 'type': 4, 'cost': 20, 'symbols': [2,0,1], 'icon': 'flower_daffodil'},
    {'name': 'Orchid', 'type': 4, 'cost': 30, 'symbols': [2,1,1], 'icon': 'flower_orchid'},
    
    {'name': 'Eye of newt', 'type': 5, 'cost': 30, 'symbols': [2,2,0], 'icon': 'animal_eye'},
    {'name': 'Bat wing', 'type': 5, 'cost': 50, 'symbols': [0,2,0], 'icon': 'animal_wing'},
    {'name': 'Owl feather', 'type': 5, 'cost': 70, 'symbols': [0,1,2], 'icon': 'animal_feather'},
    {'name': 'Dragon scale', 'type': 5, 'cost': 150, 'symbols': [1,1,1], 'icon': 'animal_scale'},
    
    {'name': 'Pepperjack', 'type': 6, 'cost': 20, 'symbols': [1,1,2], 'icon': 'cheese_pepperjack'},
    {'name': 'Cheddar', 'type': 6, 'cost': 25, 'symbols': [2,1,1], 'icon': 'cheese_cheddar'},
    {'name': 'Gruyere', 'type': 6, 'cost': 60, 'symbols': [1,1,1], 'icon': 'cheese_gruyere'},
    
    {'name': 'Nightmare', 'type': 7, 'cost': 0, 'symbols': [2,2,2], 'icon': 'dream_nightmare'},
    {'name': 'Daydream', 'type': 7, 'cost': 50, 'symbols': [0,0,0], 'icon': 'dream_daydream'},
    {'name': 'Brainstorm', 'type': 7, 'cost': 150, 'symbols': [1,1,1], 'icon': 'dream_brainstorm'},
    
    {'name': 'Tincture of boredom', 'type': 8, 'cost': 50, 'symbols': [0,0,0], 'icon': 'emotion_boredom'},
    {'name': 'Extract of fear', 'type': 8, 'cost': 100, 'symbols': [2,1,2], 'icon': 'emotion_fear'},
    {'name': 'Spark of hope', 'type': 8, 'cost': 150, 'symbols': [1,2,1], 'icon': 'emotion_hope'},
    {'name': 'Essence of love', 'type': 8, 'cost': 200, 'symbols': [1,1,1], 'icon': 'emotion_love'},
    
    {'name': '9th Life', 'type': 9, 'cost': 90, 'symbols': [1,0,2], 'icon': 'unique_catlife'},
    {'name': 'Game jam', 'type': 9, 'cost': 20, 'symbols': [2,1,2], 'icon': 'unique_gamejam'},
    {'name': 'Crystal of Power', 'type': 9, 'cost': 220, 'symbols': [2,2,1], 'icon': 'unique_manacrystal'},
    {'name': 'Essence of Vitality', 'type': 9, 'cost': 180, 'symbols': [1,2,2], 'icon': 'unique_sorcery'},
    ];